import { render, staticRenderFns } from "./post_63.vue?vue&type=template&id=4ad1778f&"
import script from "./post_63.vue?vue&type=script&lang=js&"
export * from "./post_63.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports